import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export const ITEM_HEIGHT = 48;
export const ITEM_MARGIN_BOTTOM = 8;
const BOX_SHADOW = "0 1px 7px 0 rgb(0, 0, 0, 0.08)";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    root: {
      display: "flex",
      flexWrap: "nowrap",
      height: ITEM_HEIGHT,
      marginBottom: 8
    },
    rootScheduledOnly: {
      height: "auto",
      "& $calendar": {
        height: "auto",
        boxShadow: "none"
      }
    },
    calendar: {
      position: "relative",
      height: ITEM_HEIGHT,
      display: "flex",
      flexWrap: "nowrap",
      boxShadow: BOX_SHADOW,
      overflow: "auto"
    },
    calendarScheduledOnly: {
      paddingRight: 16
    },
    calendarMonth: {
      display: "flex",
      flexWrap: "nowrap",
      minHeight: ITEM_HEIGHT,
      backgroundColor: "#fff",
      "&:last-child": {
        "& $calendarDate:last-child": {
          borderRight: "1px solid transparent"
        }
      }
    },
    scheduledOnly: {
      flexGrow: 1
    },
    calendarDate: {},
    fake: {
      minWidth: 24,
      width: "100%",
      display: "flex",
      background: "red"
    },
    fog: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: "rgba(255, 255, 255, 0.95)",
      zIndex: 2,
      overflow: "hidden"
    },
    widePane: {
      marginRight: 12,
      "&:last-child": {
        marginRight: 0
      }
    },
    nameWrapper: {
      position: "sticky",
      left: 0,
      zIndex: 5,
      minWidth: 276,
      maxWidth: 276,
      width: 276,
      height: ITEM_HEIGHT,
      display: "flex",
      flex: "auto",
      justifyContent: "flex-start",
      alignItems: "center",
      backgroundColor: "#fff",
      borderRadius: "3px 0 0 3px",
      marginBottom: ITEM_MARGIN_BOTTOM,
      boxShadow: BOX_SHADOW,
      paddingLeft: 12,
      borderRight: `1px solid ${primary.light}`,
      cursor: "pointer"
    },
    name: {
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      gap: 4,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 14,
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: 225,
      whiteSpace: "nowrap"
    },
    count: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 14
    },
    detailsLink: {
      position: "absolute",
      right: 4,
      top: 4,
      cursor: "pointer",
      fontSize: 12
    },
    detailsLinkIcon: {
      "&.MuiSvgIcon-root": {
        fontSize: 12
      }
    },
    loader: {
      padding: 0,
      width: 14,
      height: 14,
      margin: 0,
      marginLeft: 4
    },
    alert: {
      color: theme.palette.warning.dark,
      textDecoration: "underline"
    }
  };
});
